import { render, staticRenderFns } from "./PageStaffUpdate.vue?vue&type=template&id=9cfe43ce&scoped=true&"
import script from "./PageStaffUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageStaffUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageStaffUpdate.vue?vue&type=style&index=0&id=9cfe43ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfe43ce",
  null
  
)

export default component.exports